module.exports = __webpack_public_path__ + "media/images/knockoutbet__sample@2x-71a174500197635da3e9891cfbb426bf.png";